import {
  Controller,
  Get,
  Post,
  Body,
  Param,
  Patch,
} from '@nestjs/common';
import { LeadsService } from './leads.service';
import { CreateLeadsDto, UpdateLeadsDto } from '@crm/dto';
import { ApiResponseInterface } from '@crm/interface';

@Controller('leads')
export class LeadsController {
  constructor(private readonly leadsService: LeadsService) {}

  // GET /leads - fetch all leads (management only)
  @Get()
  async getAll(): Promise<ApiResponseInterface> {
    return this.leadsService.getAll();
  }

  // GET /leads/supervisor - fetch leads by managers and supervisors only
  @Get('supervisor')
  async getForSupervisor(): Promise<ApiResponseInterface> {
    return this.leadsService.getForSupervisor();
  }

  // GET /leads/user/:userId - fetch leads created by a specific user
  @Get('user/:userId')
  async getByUserId(@Param('userId') userId: string): Promise<ApiResponseInterface> {
    return this.leadsService.getByUserId(userId);
  }

  // GET /leads/:id - fetch a single lead by ID
  @Get(':id')
  async getById(@Param('id') id: string): Promise<ApiResponseInterface> {
    return this.leadsService.getById(id);
  }

  // POST /leads - create a new lead
  @Post()
  async create(@Body() dto: CreateLeadsDto): Promise<ApiResponseInterface> {
    return this.leadsService.create(dto);
  }

  // PATCH /leads - update an existing lead
  @Patch()
  async update(@Body() dto: UpdateLeadsDto): Promise<ApiResponseInterface> {
    return this.leadsService.update(dto);
  }

  // PATCH /leads/delete - soft delete a lead
  @Patch('soft-delete')
  async softDelete(@Body() dto: UpdateLeadsDto): Promise<ApiResponseInterface> {
    return this.leadsService.softDelete(dto);
  }
}